import * as Coveo from 'coveo-search-ui';
import { Component } from '@verndale/core';
import Cookies from 'js-cookie';
import { getLocalStorageData, setLocalStorageData,  } from '../helpers';
import {
  getLocationCookie,
  setLocationCookie,
  getCoveoFindACommunityFieldsToInclude,
  sendFacetQuery,
  sendCoveoGeolocationQuery,
  sendCoveoGeolocationInterfaceLoad,
  checkForHiddenQueryInHash
} from '../coveo/helpers';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $search: this.el._$('.location-selector__input'),
      $searchOmnibox: this.el._$('.CoveoOmnibox'),
      $searchOptions: this.el._$('.location-selector__dropdown select'),
      $countrySelect: this.el._$('.location-selector__country-select select'),
      $countryOptions: this.el._$$(
        '.location-selector__country-select select option'
      ),
      $careTypeSelect: this.el._$('.location-selector__care-type select'),
      $submit: this.el._$('.location-selector__search-button')
    };

    setLocalStorageData({
      isFetching: true
    });

    this.searchResultsURL = this.el.dataset.searchResultsPageUrl;
    this.filterTagUS = this.el.dataset.filterTagUs.toLowerCase();
    this.filterTagCA = this.el.dataset.filterTagCa.toLowerCase();
    this.placeholderUS = this.el.dataset.placeholderUs;
    this.placeholderCA = this.el.dataset.placeholderCa;
    this.locationAPIbaseURL = this.el.dataset.geoEndpoint;

    this.cookieName = this.el.dataset.cookieKey || 'ssl-location';
    this.lat =
      getLocalStorageData()?.lat || this.getLocationCookie()?.lat || null;
    this.lng =
      getLocalStorageData()?.lng || this.getLocationCookie()?.lng || null;
    this.countryRedirect = this.el.dataset.urlUsa;
    this.countryState = null;

    this.addCoveoEventHandlers();
    this.initCoveo();
    this.getLatLong();

    this.redirectCallbacks.bind(this);
  }

  static getLocationCookie() {
    const locationCookie = Cookies.get(this.cookieName);
    try {
      return locationCookie ? JSON.parse(locationCookie) : null;
    } catch (e) {
      return null;
    }

  }

  setStorageAndCookieLocation(args) {
    setLocalStorageData(args);
    setLocationCookie(args);
  }

  initCoveo() {
    this.apiKey = this.el.dataset.apiK;

    if (this.el.dataset.organizationId.length > 0) {
      this.organizationId = this.el.dataset.organizationId;

      Coveo.SearchEndpoint.configureCloudV2Endpoint(
        this.organizationId,
        this.apiKey
      );

      Coveo.initSearchbox(this.el, this.searchResultsURL, {
        FieldSuggestions: {
          onSelect: this.handleCoveoOnSelectSuggestion.bind(this)
        }
      });

      Coveo.Logger.disable();
    }
  }

  async getLatLong(value) {
    const localStorageData = getLocalStorageData();

    if (!value && localStorageData?.value) {
      value = localStorageData.value;
    }

    const resetLocationForCookiesAndStorage = () => {
      this.setStorageAndCookieLocation({
        lat: this.lat || null,
        lng: this.lng || null
      });
    };

    // if (localStorageData.isFetching === true) return;

    if (value) {
      setLocalStorageData({
        locationSetBySearch: 'true',
        locationSetBySearch2: 'true'
      });
    }

    if (localStorageData.lat && localStorageData.lng) {
      setLocationCookie({
        lat: localStorageData.lat,
        lng: localStorageData.lng
      });
    } else {
      resetLocationForCookiesAndStorage();
    }

    const controller = new AbortController();
    const fetchTimeout = setTimeout(() => {
      controller.abort();
    }, 250);

    const country =
      document.querySelector(
        '.find-a-community-masthead .location-selector__country-select select'
      ) || this.el.querySelector('.location-selector__country-select select');

    const fetchURL = value
      ? `${this.locationAPIbaseURL}?value=${value} ${
          country.value === 'US' ? 'USA' : 'CANADA'
        }`
      : `${this.locationAPIbaseURL}`;

    try {
      setLocalStorageData({
        isFetching: true
      });

      const response = await fetch(fetchURL);
      const responseJson = await response.json();
      const inputValue = value || this.dom.$locationInput.value;

      if (responseJson) {
        this.lat = responseJson.Latitude;
        this.lng = responseJson.Longitude;

        if (
          !localStorageData ||
          localStorageData.lat !== this.lat ||
          localStorageData.lng !== this.lng
        ) {
          if (!localStorageData?.value) {
            this.setStorageAndCookieLocation({ value: null });
          }
          resetLocationForCookiesAndStorage();
        }

        if (responseJson.IsState) {
          this.countryState = responseJson.State;
          this.setStorageAndCookieLocation({ state: this.countryState });
        } else {
          this.countryState = null;
          this.setStorageAndCookieLocation({ state: null });
        }

        this.setStorageAndCookieLocation({
          usingIp: responseJson.IP ? true : false
        });

        if (inputValue && localStorageData.value !== inputValue) {
          setLocalStorageData({
            value: inputValue,
            sw: null,
            sw2: null,
            nearbyCommunitiesRow: null
          });
          setLocationCookie({
            value: inputValue
          });
        }

        clearTimeout(fetchTimeout);
        return responseJson;
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLocalStorageData({
        isFetching: false
      });
    }
  }

  addCoveoEventHandlers() {
    Coveo.$$(this.el).on(
      'afterInitialization',
      this.handleCoveoAfterInitialization.bind(this)
    );
    Coveo.$$(this.el).on('newQuery', this.handleCoveoNewQuery.bind(this));
    Coveo.$$(this.el).on(
      'buildingQuery',
      this.handleCoveoBuildingQuery.bind(this)
    );
    Coveo.$$(this.el).on(
      'beforeRedirect',
      this.handleCoveoBeforeRedirect.bind(this)
    );
  }

  redirectCallbacks(key) {
    return {
      resultsPage: async (args, self) => {
        if (!this.dom.$careTypeSelect.value && !this.dom.$locationInput.value) {
          args.searchPageUri = `${self.dataset.searchNoInfoRedirect}`;
        } else {
          args.cancel = true;
          const response = await this.getLatLong(this.dom.$locationInput.value);
          const { Latitude, Longitude, IsState, State } = response || {};

          window.location.href = IsState
            ? `${this.countryRedirect}${self.dataset.searchWithInfoRedirect}/${State}`
            : `${this.countryRedirect}${
                self.dataset.searchWithInfoRedirect
              }#f:@ssl_levelsofcare=[${encodeURIComponent(
                this.dom.$careTypeSelect.value
              )}]&latitude=${Latitude}&longitude=${Longitude}&source=${
                this.dom.$countrySelect.value
              }`;
        }
      },
      homeMasthead: async (args, self) => {
        if (!this.dom.$careTypeSelect.value && !this.dom.$locationInput.value) {
          args.searchPageUri = `${this.countryRedirect}${self.dataset.searchNoInfoRedirect}`;
        } else {
          args.cancel = true;
          const response = await this.getLatLong(this.dom.$locationInput.value);
          const { Latitude, Longitude, IsState, State } = response;

          window.location.href = IsState
            ? `${this.countryRedirect}${self.dataset.searchWithInfoRedirect}/${State}`
            : `${this.countryRedirect}${
                self.dataset.searchWithInfoRedirect
              }#f:@ssl_levelsofcare=[${encodeURIComponent(
                this.dom.$careTypeSelect.value
              )}]&latitude=${Latitude}&longitude=${Longitude}&source=${
                this.dom.$countrySelect.value
              }`;
        }
      },
      mapResultsPage: async (args, self) => {
        args.cancel = true;
        if (this.dom.$careTypeSelect) {
          Coveo.state(
            self,
            'hq',
            `@ssl_levelsofcare=="[${encodeURIComponent(
              this.dom.$careTypeSelect.value
            )}]" $qf(function:'dist(@ssl_latitude_d,@ssl_longitude_d,${
              this.lat
            },${this.lng})', fieldName: 'distance')`
          );
        } else {
          const response = await this.getLatLong(this.dom.$locationInput.value);
          const { Latitude, Longitude, IsState, State } = response || {};

          if (!Latitude || !Longitude) return;

          if (!IsState) {
            Coveo.state(
              self,
              'hq',
              `$qf(function:'dist(@ssl_latitude_d,@ssl_longitude_d,${Latitude},${Longitude})', fieldName: 'distance')`
            );
            Coveo.state(self, 'latitude', Latitude);
            Coveo.state(self, 'longitude', Longitude);
            Coveo.state(self, 'source', this.dom.$countrySelect.value);
            window.location.href = `${this.el.dataset.searchResultsPageUrl}#hq=$qf(function:'dist(@ssl_latitude_d,@ssl_longitude_d,${Latitude},${Longitude})', fieldName: 'distance')&latitude=${Latitude}&longitude=${Longitude}&source=${this.dom.$countrySelect.value}`;
          } else {
            Coveo.logSearchEvent(
              self,
              {
                name: 'locationSelectorMapResultsPage',
                type: ''
              },
              {
                latitude: Latitude,
                longitude: Longitude
              }
            );
            window.location.href = `${this.countryRedirect}${
              this.el.dataset.searchWithInfoRedirect || '/communities'
            }/${State}`;
          }

          Coveo.executeQuery(self);
        }
      },
      shareCommunities: async args => {
        args.cancel = true;
      },
      communityRow: async args => {
        args.cancel = true;
      }
    }[key];
  }

  async handleCoveoBeforeRedirect(e, args) {
    this.countryRedirect =
      this.dom.$countrySelect.value === 'CA'
        ? this.el.dataset.urlCanada
        : this.countryRedirect;

    const pages = new Map([
      [
        'resultsPage',
        document._$('.nearby-communities-row-with-search__coveo')
      ],
      ['homeMasthead', document._$('.homepage-masthead')],
      ['mapResultsPage', document._$('.find-a-community-map-view-row')],
      ['shareCommunities', document._$('.share-communities')],
      ['communityRow', document._$('.community-row')]
    ]);

    const currentPageKey = [...pages].find(([_, value]) => !!value)[0];

    this.setStorageAndCookieLocation({
      lat: this.lat,
      lng: this.lng,
      value: this.dom.$locationInput.value || '',
      country: this.dom.$countrySelect.value,
      state: this.countryState
    });

    if (
      this.el.dataset.searchWithInfoRedirect &&
      this.dom.$careTypeSelect.value &&
      this.dom.$locationInput.value
    ) {
      args.cancel = true;
      const { IsState, State } = await this.getLatLong(
        this.dom.$locationInput.value
      );

      if (IsState) {
        this.countryState = State;
        this.setStorageAndCookieLocation({ state: this.countryState });
        window.location.href = `${this.el.dataset.searchWithInfoRedirect}/${State}`;
      } else {
        this.countryState = null;
        this.setStorageAndCookieLocation({ state: null });
        window.location.href = `${this.el.dataset.searchWithInfoRedirect}`;
      }
    } else {
      args.searchPageUri =
        this.el.dataset.searchNoInfoRedirect &&
        `${this.el.dataset.searchNoInfoRedirect}`;
    }

    if (this.dom.$careTypeSelect && this.dom.$careTypeSelect.value) {
      args.searchPageUri += `#f:@ssl_levelsofcare=[${encodeURIComponent(
        this.dom.$careTypeSelect.value
      )}]`;
      currentPageKey &&
        this.redirectCallbacks(currentPageKey)(args, pages.get(currentPageKey));
    } else {
      currentPageKey &&
        this.redirectCallbacks(currentPageKey)(args, pages.get(currentPageKey));
    }
  }

  handleCoveoAfterInitialization() {
    const redirectUrl =
      this.el.dataset.searchWithInfoRedirect || '/communities';
    let isPlainCommunities = false;

    this.dom.$locationInput = this.el._$('.CoveoOmnibox input');

    this.dom.$locationInput._on(
      'input',
      this.handleButtonEnableDisable.bind(this)
    );

    this.handleButtonEnableDisable({
      target: this.dom.$locationInput
    });

    this.setPlaceholder();

    const localStorage = getLocalStorageData();
    const locationCookie = this.getLocationCookie();
    const inputValue = locationCookie?.value || localStorage?.value;

    if (!localStorage?.value && locationCookie?.value) {
      setLocalStorageData({ value: locationCookie.value });
    }

    if (localStorage?.value && !locationCookie?.value) {
      setLocationCookie({ value: localStorage.value });
    }

    if (window.location.href.endsWith(redirectUrl)) isPlainCommunities = true;

    if (inputValue && !isPlainCommunities) {
      this.dom.$locationInput.value = inputValue;
      this.handleButtonEnableDisable({
        target: this.dom.$locationInput
      });
    }
  }

  async handleCoveoNewQuery() {
    const { Latitude, Longitude } = await this.getLatLong(
      this.dom.$locationInput.value
    );

    if (Latitude && Longitude) {
      Coveo.state(
        this.el,
        'hq',
        `$qf(function:'dist(@ssl_latitude_d,@ssl_longitude_d,${Latitude},${Longitude})', fieldName: 'distance')`
      );
    }
  }

  handleCoveoBuildingQuery(e, args) {
    const shareCommunities = document._$('.share-communities');
    const communityRow = document._$('.community-row');
    if (shareCommunities || communityRow) {
      args.cancel = true;
    }
  }

  handleCoveoOnSelectSuggestion(selectedValue, populateOmniboxEventArgs) {
    Coveo.get(this.dom.$searchOmnibox).setText(selectedValue);
    populateOmniboxEventArgs.closeOmnibox();
  }

  setInputTooltip() {
    const inputPlaceholder = this.dom.$searchOmnibox._$('input').placeholder;
    this.dom.$searchOmnibox._$('input').setAttribute('title', inputPlaceholder);
  }

  setPlaceholder(filterTag) {
    if (filterTag === this.filterTagUS)
      this.dom.$searchOmnibox._$('input').placeholder = this.placeholderUS;
    else if (filterTag === this.filterTagCA)
      this.dom.$searchOmnibox._$('input').placeholder = this.placeholderCA;
    this.setInputTooltip();
  }

  addListeners() {
    this.dom.$countrySelect.addEventListener(
      'option',
      this.handleCountryChange.bind(this)
    );
    if (this.dom.$searchOptions)
      this.dom.$searchOptions.addEventListener(
        'option',
        this.handleOptionChange.bind(this)
      );
  }

  handleOptionChange(e) {
    const selectedDropdownOption = [...e.currentTarget].find(
      option => option.getAttribute('aria-selected') === 'true'
    ).value;
  }

  handleCountryChange(e) {
    const selectedCountryFilterTag = [...e.currentTarget]
      .find(option => option.getAttribute('aria-selected') === 'true')
      .dataset.filterTag.toLowerCase();

    if (selectedCountryFilterTag) this.setPlaceholder(selectedCountryFilterTag);
  }

  handleButtonEnableDisable(e) {
    if (this.el.classList.contains('location-selector--submit-always-enabled'))
      return;
    this.dom.$submit.disabled = !e.target?.value;

    const nearbySearch = document.querySelector(
      '.nearby-communities-row-with-search'
    );
    if (nearbySearch) {
      nearbySearch.querySelector(
        '.location-selector__search-button'
      ).disabled = false;
    }
  }
}

export default Module;
